import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Video, Wand2, ArrowRight, Check, Shield, Zap, Globe } from 'lucide-react';

const Landing: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'black', color: '#d1d5db', fontFamily: 'Inter, sans-serif' }}>
      {/* Header */}
      <header style={{ borderBottom: '1px solid #1f2937', backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(12px)', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '0 1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '4rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Sparkles style={{ width: '2rem', height: '2rem', color: '#3b82f6' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'white' }}>Faissal SaaS</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <Link to="/login" style={{ color: '#9ca3af', padding: '0.5rem 1rem', textDecoration: 'none' }}>Connexion</Link>
              <Link to="/login" style={{ backgroundColor: '#2563eb', color: 'white', padding: '0.5rem 1rem', borderRadius: '0.5rem', textDecoration: 'none' }}>Commencer</Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{ padding: '5rem 1rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '56rem', margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.25rem 0.75rem', borderRadius: '9999px', backgroundColor: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.2)', fontSize: '0.875rem', color: '#60a5fa', marginBottom: '1.5rem' }}>
            <span style={{ width: '0.5rem', height: '0.5rem', borderRadius: '9999px', backgroundColor: '#4ade80' }} />
            Deux outils professionnels disponibles
          </div>
          
          <h1 style={{ fontSize: '3.5rem', fontWeight: 'bold', color: 'white', marginBottom: '1.5rem', lineHeight: 1.1 }}>
            Vos outils <span style={{ background: 'linear-gradient(to right, #60a5fa, #a855f7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>créatifs</span><br />
            en un seul endroit
          </h1>
          
          <p style={{ fontSize: '1.25rem', color: '#9ca3af', marginBottom: '2rem', maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto' }}>
            Accédez instantanément à RecipeVisual et ReelCleaner. Générez des visuels professionnels et nettoyez vos vidéos en quelques clics.
          </p>
          
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'center' }}>
            <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', backgroundColor: '#2563eb', color: 'white', padding: '1rem 2rem', borderRadius: '0.75rem', fontWeight: 600, textDecoration: 'none' }}>
              Se connecter <ArrowRight style={{ width: '1.25rem', height: '1.25rem' }} />
            </Link>
            <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', backgroundColor: '#111827', border: '1px solid #1f2937', color: 'white', padding: '1rem 2rem', borderRadius: '0.75rem', fontWeight: 600, textDecoration: 'none' }}>
              Créer un compte gratuit
            </Link>
          </div>
        </div>
      </section>

      {/* Tools Section */}
      <section style={{ padding: '4rem 1rem', backgroundColor: '#030712', borderTop: '1px solid #111827', borderBottom: '1px solid #111827' }}>
        <div style={{ maxWidth: '72rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>Nos outils professionnels</h2>
            <p style={{ color: '#9ca3af' }}>Des solutions puissantes pour créer du contenu de qualité</p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            {/* RecipeVisual */}
            <div style={{ backgroundColor: '#111827', border: '1px solid #1f2937', borderRadius: '1rem', padding: '2rem' }}>
              <div style={{ width: '4rem', height: '4rem', borderRadius: '0.75rem', background: 'linear-gradient(to bottom right, #a855f7, #ec4899)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem' }}>
                <Wand2 style={{ width: '2rem', height: '2rem', color: 'white' }} />
              </div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'white', marginBottom: '0.75rem' }}>RecipeVisual</h3>
              <p style={{ color: '#9ca3af', marginBottom: '1.5rem' }}>
                Générez des visuels Pinterest professionnels pour vos recettes en quelques clics. Templates optimisés pour maximiser votre reach.
              </p>
              <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#60a5fa', textDecoration: 'none' }}>
                Se connecter pour accéder <ArrowRight style={{ width: '1rem', height: '1rem' }} />
              </Link>
            </div>

            {/* ReelCleaner */}
            <div style={{ backgroundColor: '#111827', border: '1px solid #1f2937', borderRadius: '1rem', padding: '2rem' }}>
              <div style={{ width: '4rem', height: '4rem', borderRadius: '0.75rem', background: 'linear-gradient(to bottom right, #3b82f6, #06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem' }}>
                <Video style={{ width: '2rem', height: '2rem', color: 'white' }} />
              </div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'white', marginBottom: '0.75rem' }}>ReelCleaner</h3>
              <p style={{ color: '#9ca3af', marginBottom: '1.5rem' }}>
                Téléchargez et nettoyez vos vidéos Reels & TikToks sans métadonnées. Légendes optimisées par IA incluses.
              </p>
              <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#60a5fa', textDecoration: 'none' }}>
                Se connecter pour accéder <ArrowRight style={{ width: '1rem', height: '1rem' }} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '4rem 1rem' }}>
        <div style={{ maxWidth: '72rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>Pourquoi choisir Faissal SaaS ?</h2>
            <p style={{ color: '#9ca3af' }}>Tout ce dont vous avez besoin pour créer du contenu</p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem' }}>
            {[
              { icon: Shield, title: 'Authentification sécurisée', desc: 'Connexion via Firebase avec Google ou Email' },
              { icon: Zap, title: 'Accès illimité', desc: 'Utilisez tous les outils sans limitation' },
              { icon: Globe, title: 'Disponible partout', desc: "Accédez à vos outils depuis n'importe où" },
              { icon: Check, title: 'Mises à jour gratuites', desc: 'Nouvelles fonctionnalités régulièrement' },
            ].map((feature, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ width: '3.5rem', height: '3.5rem', margin: '0 auto 1rem', borderRadius: '0.75rem', backgroundColor: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#60a5fa' }}>
                  <feature.icon style={{ width: '1.75rem', height: '1.75rem' }} />
                </div>
                <h3 style={{ fontWeight: 600, color: 'white', marginBottom: '0.5rem' }}>{feature.title}</h3>
                <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '4rem 1rem', backgroundColor: '#030712', borderTop: '1px solid #111827', borderBottom: '1px solid #111827' }}>
        <div style={{ maxWidth: '56rem', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>Prêt à commencer ?</h2>
          <p style={{ color: '#9ca3af', marginBottom: '2rem' }}>
            Connectez-vous maintenant et accédez à tous nos outils gratuitement.
          </p>
          <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', backgroundColor: 'white', color: 'black', padding: '1rem 2rem', borderRadius: '0.75rem', fontWeight: 600, textDecoration: 'none' }}>
            Se connecter gratuitement <ArrowRight style={{ width: '1.25rem', height: '1.25rem' }} />
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #111827', padding: '2rem 1rem' }}>
        <div style={{ maxWidth: '72rem', margin: '0 auto', textAlign: 'center', color: '#6b7280' }}>
          <p>© 2026 Faissal SaaS. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
